import type { AppState } from 'state/state.model';

import type { Quote } from './quote.model';

function getQuote(appState: AppState, quoteId: string): Quote | undefined {
  return appState.secondaryMarket.realtimeQuote.quote[quoteId];
}

export function getSecondaryQuoteSettlementPrice(appState: AppState, quoteId: string) {
  return getQuote(appState, quoteId)?.settlementPrice;
}

export function getSecondaryQuoteTradeAuthorizationStartTimestampMilliseconds(appState: AppState, quoteId: string) {
  const start = getQuote(appState, quoteId)?.tradeAuthorizationStart;
  return start?.getTime() ?? undefined;
}

export function getSecondaryQuoteTradeAuthorizationDurationInMilliseconds(appState: AppState, quoteId: string) {
  const durationInSeconds = getQuote(appState, quoteId)?.timeToTradeInSeconds;
  return durationInSeconds !== undefined ? durationInSeconds * 1000 : undefined;
}

export function getSecondaryQuoteTradeDate(appState: AppState, quoteId: string) {
  return getQuote(appState, quoteId)?.tradeDate;
}

export function getSecondaryQuoteUpfrontFee(appState: AppState, quoteId: string) {
  return getQuote(appState, quoteId)?.upfrontFee;
}

export function getSecondaryQuotePriceType(appState: AppState, quoteId: string) {
  return getQuote(appState, quoteId)?.priceType;
}

export function getSecondaryQuotePrice(appState: AppState, quoteId: string) {
  return getQuote(appState, quoteId)?.price;
}

export function getSecondaryQuoteCashAmount(appState: AppState, quoteId: string) {
  return getQuote(appState, quoteId)?.cashAmount;
}

export function getSecondaryQuoteDeductedFee(appState: AppState, quoteId: string) {
  return getQuote(appState, quoteId)?.deductedFee;
}

export function getSecondaryQuoteAccruedCoupon(appState: AppState, quoteId: string) {
  return getQuote(appState, quoteId)?.accruedCoupon;
}

export function getSecondaryQuoteSettlementDate(appState: AppState, quoteId: string) {
  return getQuote(appState, quoteId)?.settlementDate;
}

export function getSecondaryQuoteQuotationType(appState: AppState, quoteId: string) {
  return getQuote(appState, quoteId)?.quotationType;
}

export function getSecondaryQuoteCorrelationId(appState: AppState, quoteId: string) {
  return getQuote(appState, quoteId)?.correlationId;
}
